import api from '../../../tools/api-tools'
import { mainWeb } from '../../../config/net'

class RenewalModel {
  constructor () {
    this.imgObj = {
      '服装鞋帽·行业版': require('../../../assets/images/icon/clothes.png'),
      '母婴·行业版': require('../../../assets/images/icon/pregenant.png'),
      '丽人·行业版': require('../../../assets/images/icon/massage.png'),
      '宠物·行业版': require('../../../assets/images/icon/pet.png'),
      '手机数码·行业版': require('../../../assets/images/icon/electronic.png'),
      '旗舰·行业版': require('../../../assets/images/icon/dressup.png'),
      '眼镜·行业版': require('../../../assets/images/icon/glasses.png'),
      '高级版': require('../../../assets/images/icon/superior.png')
    }
  }

  getBusInfo (id) {
    return api.post(`${mainWeb}/OrderInfo/ajax/action.ashx?type=businfo&goodsId=${id}&goodsType=1&quantity=12&couponcode=&remark=`).then(res => {
      let data = res.data || {}
      try {
        if (typeof data === 'string') data = JSON.parse(data)
      } catch (e) {
        data = {}
      }
      let versionText = data.DisplayName
      let versionImg = this.imgObj[versionText]
      let relMoney = data.AbleMoney
      let relEveryDayMoney = (data.AbleMoney / 365).toFixed(2)
      let needMoney = '￥' + data.RealMoney + '/年'
      let realMoney = data.RealMoney
      let everyNeedMoney = '￥' + (data.RealMoney / 365).toFixed(2) + '/天'
      return { versionText, versionImg, relMoney, relEveryDayMoney, needMoney, everyNeedMoney, realMoney }
    }).catch(e => {
      return e
    })
  }

  getOrderSaasCount () {
    return api.post(`${mainWeb}/OrderInfo/ajax/action.ashx?type=getordersaascount`, null).then(res => {
      let data = res.data || {}
      let leftDate = data.Item2
      return { leftDate }
    }).catch(e => {
      return e
    })
  }
}

export default RenewalModel



// WEBPACK FOOTER //
// ./src/model/order/renewal/index.js